/* Mattress Home | Bidirectional variant selector v1.0
 * Works with product-form.liquid and product-swatch.liquid supplied together.
 * Keep theme's native variant select/change handlers for price, media and cart.
 */
(function () {
  'use strict';
  if (window.MHVariantSelectorLoaded) return;
  window.MHVariantSelectorLoaded = true;

  var STYLE_ID = 'mh-variant-selector-style';
  if (!document.getElementById(STYLE_ID)) {
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent = '[data-mh-variant-form] .swatch-element.mh-is-unavailable{opacity:.38;cursor:not-allowed}' +
      '[data-mh-variant-form] .swatch-element.mh-is-unavailable label{cursor:not-allowed}' +
      '[data-mh-variant-form] .swatch-element.mh-is-incompatible:not(.mh-is-unavailable){opacity:.58}' +
      '[data-mh-variant-form] .swatch-element.mh-is-incompatible:not(.mh-is-unavailable) label{cursor:pointer}' +
      '[data-mh-variant-form] .swatch-element.mh-is-selected{outline:2px solid #2C265D;outline-offset:2px}' +
      '[data-mh-variant-form] .swatch-element.mh-is-soldout{opacity:.48}' +
      '[data-mh-variant-form] .swatch-element.mh-is-soldout label{cursor:not-allowed}';
    document.head.appendChild(css);
  }

  function variantsFor(form) {
    try {
      var product = JSON.parse(form.getAttribute('data-product') || '{}');
      return Array.isArray(product.variants) ? product.variants : [];
    } catch (error) {
      console.warn('[MH variants] Could not read product JSON', error);
      return [];
    }
  }

  function optionInputs(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-mh-variant-swatch]'))
      .sort(function (a, b) { return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex); })
      .map(function (group) {
        return Array.prototype.slice.call(group.querySelectorAll('input[type="radio"][data-mh-option-input]'));
      });
  }

  function chosen(groups) {
    return groups.map(function (inputs) {
      var checked = inputs.find(function (input) { return input.checked; });
      return checked ? checked.value : null;
    });
  }

  function getOptions(variant) {
    return Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(function (x) { return x != null; });
  }

  function matches(variant, selections) {
    var values = getOptions(variant);
    return selections.every(function (value, index) { return value == null || values[index] === value; });
  }

  function findVariant(variants, selections, requireAvailable) {
    return variants.find(function (variant) {
      return (!requireAvailable || variant.available) && matches(variant, selections);
    });
  }

  function selectInputs(groups, values) {
    groups.forEach(function (inputs, index) {
      inputs.forEach(function (input) { input.checked = input.value === values[index]; });
    });
  }

  function notifyNativeSelect(form, variant) {
    var select = form.querySelector('select[data-variants][name="id"]');
    if (!select || String(select.value) === String(variant.id)) return;
    select.value = String(variant.id);
    // Trigger the existing theme's variant change logic (prices, image, availability).
    if (window.jQuery) window.jQuery(select).trigger('change');
    else select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function refresh(form, groups, variants, selected) {
    groups.forEach(function (inputs, index) {
      inputs.forEach(function (input) {
        var element = input.nextElementSibling;
        if (!element || !element.classList.contains('swatch-element')) return;
        var globally = variants.some(function (variant) { return variant.available && getOptions(variant)[index] === input.value; });
        var constraints = selected.slice();
        constraints[index] = input.value;
        var exactAvailable = variants.some(function (variant) { return variant.available && matches(variant, constraints); });
        var exactExists = variants.some(function (variant) { return matches(variant, constraints); });
        var state = exactAvailable ? 'available' : exactExists ? 'soldout' : 'unavailable';
        // A value that is available elsewhere remains clickable so it can be selected first;
        // other selections will automatically move to a compatible variant.
        input.disabled = !globally;
        element.classList.toggle('mh-is-unavailable', !globally);
        element.classList.toggle('mh-is-incompatible', globally && !exactAvailable);
        element.classList.toggle('mh-is-soldout', !exactAvailable && exactExists);
        element.classList.toggle('mh-is-selected', input.checked);
        element.classList.toggle('available', exactAvailable);
        element.classList.toggle('soldout', !exactAvailable);
        element.setAttribute('data-mh-availability', state);
        element.setAttribute('aria-disabled', String(!globally));
        element.tabIndex = globally ? 0 : -1;
      });
    });
  }

  function init(form) {
    if (form.dataset.mhVariantInitialized === 'true') return;
    var variants = variantsFor(form);
    var groups = optionInputs(form);
    var nativeSelect = form.querySelector('select[data-variants][name="id"]');
    if (!nativeSelect || !variants.length || !groups.length || groups.some(function (group) { return !group.length; })) return;
    form.dataset.mhVariantInitialized = 'true';
    var updating = false;

    function commit(preferredIndex, preferredValue) {
      if (updating) return;
      updating = true;
      try {
        var selections = chosen(groups);
        if (preferredIndex != null) selections[preferredIndex] = preferredValue;
        var variant = findVariant(variants, selections, true);
        if (!variant) {
          // Respect the option just clicked, preserve as many other choices as possible.
          var candidates = variants.filter(function (item) {
            return item.available && (preferredIndex == null || getOptions(item)[preferredIndex] === preferredValue);
          });
          candidates.sort(function (a, b) {
            function score(v) {
              return getOptions(v).reduce(function (sum, value, i) {
                return sum + (i !== preferredIndex && value === selections[i] ? 1 : 0);
              }, 0);
            }
            return score(b) - score(a);
          });
          variant = candidates[0];
        }
        if (!variant) {
          // Product entirely sold out: keep the selected variant for native sold-out handling.
          variant = findVariant(variants, selections, false) || variants[0];
        }
        var values = getOptions(variant);
        selectInputs(groups, values);
        notifyNativeSelect(form, variant);
        // Theme's legacy mapping can mutate swatch classes during its own handlers.
        window.setTimeout(function () { refresh(form, groups, variants, values); }, 0);
        refresh(form, groups, variants, values);
      } finally {
        updating = false;
      }
    }

    groups.forEach(function (inputs, index) {
      inputs.forEach(function (input) {
        input.addEventListener('change', function () { commit(index, input.value); });
      });
    });

    // The theme can change the native variant select via URL, quick-shop or other widgets.
    nativeSelect.addEventListener('change', function () {
      if (updating) return;
      var variant = variants.find(function (item) { return String(item.id) === String(nativeSelect.value); });
      if (!variant) return;
      selectInputs(groups, getOptions(variant));
      window.setTimeout(function () { refresh(form, groups, variants, getOptions(variant)); }, 0);
    });

    // Keep the initial URL-selected or first available variant consistent with swatches.
    var initial = variants.find(function (item) { return String(item.id) === String(nativeSelect.value); }) ||
      variants.find(function (item) { return item.available; }) || variants[0];
    selectInputs(groups, getOptions(initial));
    refresh(form, groups, variants, getOptions(initial));
  }

  function scan() {
    document.querySelectorAll('[data-mh-variant-form]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  // Handles dynamically inserted quick-shop forms without reinitializing existing forms.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.setTimeout(function () { pending = false; scan(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
